const bookingPlatformTransformer = data => {
  const transformedData = data?.map(item => {
    return {
      ...item,
      label: item?.title,
      value: item?.id,
      payload: {
        id: item?.id,
        title: item?.title,
      },
    }
  })
  return transformedData
}

export default bookingPlatformTransformer
